import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUploadCloud = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 16,
	viewBox: "0 0 22 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.73366 0.999919C6.24368 0.999919 4.23366 2.98732 4.23366 5.42849C4.23366 5.76244 4.27116 6.08739 4.34202 6.39939C4.36168 6.48593 4.34601 6.57673 4.2985 6.65168C4.25099 6.72663 4.17555 6.77955 4.0889 6.7987C2.50849 7.14798 1.33366 8.53713 1.33366 10.1904C1.33366 12.1056 2.91089 13.6666 4.86699 13.6666H8.4734C8.6575 13.6666 8.80674 13.8158 8.80674 13.9999C8.80674 14.184 8.6575 14.3333 8.4734 14.3333H4.86699C2.55209 14.3333 0.666992 12.4831 0.666992 10.1904C0.666992 8.32364 1.91716 6.7501 3.63059 6.23007C3.58873 5.96884 3.56699 5.70107 3.56699 5.42849C3.56699 2.60981 5.88488 0.333252 8.73366 0.333252C11.1339 0.333252 13.1558 1.94835 13.7344 4.14278L16.167 4.14278C19.0158 4.14278 21.3337 6.41933 21.3337 9.23801C21.3337 12.0567 19.0158 14.3333 16.167 14.3333H13.8272C13.6432 14.3333 13.4939 14.184 13.4939 13.9999C13.4939 13.8158 13.6432 13.6666 13.8272 13.6666H16.167C18.657 13.6666 20.667 11.6792 20.667 9.23801C20.667 6.79684 18.657 4.80944 16.167 4.80944L13.4703 4.80945C13.3121 4.80945 13.1758 4.6983 13.1438 4.54338C12.728 2.52495 10.914 0.999919 8.73366 0.999919Z",
			fill: "#545E6B"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M11.1135 6.84009C11.2056 6.84009 11.2889 6.8774 11.3492 6.93772L14.6026 10.1911C14.7327 10.3212 14.7327 10.5323 14.6026 10.6625C14.4724 10.7926 14.2613 10.7926 14.1312 10.6625L11.4469 7.97816V15.6001C11.4469 15.7842 11.2976 15.9334 11.1135 15.9334C10.9294 15.9334 10.7802 15.7842 10.7802 15.6001V7.97816L8.09589 10.6625C7.96572 10.7926 7.75466 10.7926 7.62449 10.6625C7.49431 10.5323 7.49431 10.3212 7.62449 10.1911L10.8776 6.9379C10.938 6.87747 11.0214 6.84009 11.1135 6.84009Z",
			fill: "#545E6B"
		})
	]
});
const ForwardRef = forwardRef(SvgUploadCloud);
export { ForwardRef as ReactComponent };
